'use client';

import type { FragmentType } from '@packages/gql/generated/shopping';
import type { DownloadsCardFragmentFragmentDoc } from '@packages/gql/generated/shopping/DownloadsCardFragmentFragmentDoc';
import { Card, CardContent, CardHeader } from '@packages/shared/src/ui/Card/Card';
import { useIntl } from 'react-intl';
import { unmask } from '@packages/gql/src/betterMasking';
import { DownloadItem } from '../DownloadItem/DownloadItem.client';

/* GraphQL */ `
  fragment DownloadsCardFragment on Product {
    downloads {
      type
      link
    }
  }
`;
export type DownloadsCardProps = {
  data: FragmentType<typeof DownloadsCardFragmentFragmentDoc>;
};

/**
 * DownloadsCard component displays all available downloads
 * */
export const DownloadsCard = ({ data }: DownloadsCardProps) => {
  const { formatMessage } = useIntl();
  const { downloads } = unmask<typeof DownloadsCardFragmentFragmentDoc>(data);

  if (!downloads.length) {
    return null;
  }

  return (
    <Card>
      <CardHeader hasDivider>
        {formatMessage({
          id: 'downloadsCard.header',
          defaultMessage: 'Downloads',
        })}
      </CardHeader>
      <CardContent className="space-y-2 pb-2.5">
        {downloads.map(({ type, link }, idx) => (
          <DownloadItem
            type={type}
            link={link}
            // eslint-disable-next-line react/no-array-index-key
            key={idx}
          />
        ))}
      </CardContent>
    </Card>
  );
};
